import { enGB, enUS, Locale, pl } from "date-fns/locale";
import i18n from "i18next";

import availableLanguages from "./availableLanguages";

type Lang = (typeof availableLanguages)[number]["language"];

const languageToDateFnsLocaleMapping: Record<Lang | string, Locale> = {
  GB: enGB,
  pl: pl,
  PL: pl,
  US: enUS,
  en: enGB,
};

const languageToStringLocaleMapping: Record<Lang | string, "en-GB" | "pl" | "en-US"> = {
  GB: "en-GB",
  pl: "pl",
  US: "en-US",
  en: "en-GB",
};

const languageToLanguageCodeMapping: Record<Lang | string, string> = {
  US: "en",
  GB: "en",
  pl: "pl",
  PL: "pl",
};

export const getDateFnsLocale = (language: string) => {
  return languageToDateFnsLocaleMapping[language as Lang] || enGB;
};
export const currentLanguageLocale = () => {
  return getDateFnsLocale(i18n.language);
};
export const getDateStringLocale = (language: string) => {
  return languageToStringLocaleMapping[language] || "en-GB";
};
export const getLanguageCode = (language: string) => {
  return languageToLanguageCodeMapping[language] || "en";
};
